module.exports = __webpack_public_path__ + "img/logo-blue.9a05bf77.png";